/*! For license information please see index.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["token-input"] = t(require("react")) : e.TokenInput = t(e.React);
}(this, function (e) {
  return (() => {
    var t = {
        184: (e, t) => {
          var n;
          !function () {
            "use strict";

            var r = {}.hasOwnProperty;
            function o() {
              for (var e = [], t = 0; t < arguments.length; t++) {
                var n = arguments[t];
                if (n) {
                  var a = typeof n;
                  if ("string" === a || "number" === a) e.push(n);else if (Array.isArray(n)) {
                    if (n.length) {
                      var i = o.apply(null, n);
                      i && e.push(i);
                    }
                  } else if ("object" === a) if (n.toString === Object.prototype.toString) for (var u in n) r.call(n, u) && n[u] && e.push(u);else e.push(n.toString());
                }
              }
              return e.join(" ");
            }
            e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
              return o;
            }.apply(t, [])) || (e.exports = n);
          }();
        },
        703: (e, t, n) => {
          "use strict";

          var r = n(414);
          function o() {}
          function a() {}
          a.resetWarningCache = o, e.exports = function () {
            function e(e, t, n, o, a, i) {
              if (i !== r) {
                var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw u.name = "Invariant Violation", u;
              }
            }
            function t() {
              return e;
            }
            e.isRequired = e;
            var n = {
              array: e,
              bigint: e,
              bool: e,
              func: e,
              number: e,
              object: e,
              string: e,
              symbol: e,
              any: e,
              arrayOf: t,
              element: e,
              elementType: e,
              instanceOf: t,
              node: e,
              objectOf: t,
              oneOf: t,
              oneOfType: t,
              shape: t,
              exact: t,
              checkPropTypes: a,
              resetWarningCache: o
            };
            return n.PropTypes = n, n;
          };
        },
        697: (e, t, n) => {
          e.exports = n(703)();
        },
        414: e => {
          "use strict";

          e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        639: (e, t, n) => {
          "use strict";

          var r = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            },
            o = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }
              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
            a = n(787),
            i = l(a),
            u = l(n(863));
          function l(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }
          var s = {
              position: "absolute",
              top: 0,
              left: 0,
              visibility: "hidden",
              height: 0,
              overflow: "scroll",
              whiteSpace: "pre"
            },
            c = ["extraWidth", "injectStyles", "inputClassName", "inputRef", "inputStyle", "minWidth", "onAutosize", "placeholderIsMinWidth"],
            f = function (e, t) {
              t.style.fontSize = e.fontSize, t.style.fontFamily = e.fontFamily, t.style.fontWeight = e.fontWeight, t.style.fontStyle = e.fontStyle, t.style.letterSpacing = e.letterSpacing, t.style.textTransform = e.textTransform;
            },
            p = !("undefined" == typeof window || !window.navigator) && /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent),
            d = function () {
              return p ? "_" + Math.random().toString(36).substr(2, 12) : void 0;
            },
            y = function (e) {
              function t(e) {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);
                var n = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                return n.inputRef = function (e) {
                  n.input = e, "function" == typeof n.props.inputRef && n.props.inputRef(e);
                }, n.placeHolderSizerRef = function (e) {
                  n.placeHolderSizer = e;
                }, n.sizerRef = function (e) {
                  n.sizer = e;
                }, n.state = {
                  inputWidth: e.minWidth,
                  inputId: e.id || d(),
                  prevId: e.id
                }, n;
              }
              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), o(t, null, [{
                key: "getDerivedStateFromProps",
                value: function (e, t) {
                  var n = e.id;
                  return n !== t.prevId ? {
                    inputId: n || d(),
                    prevId: n
                  } : null;
                }
              }]), o(t, [{
                key: "componentDidMount",
                value: function () {
                  this.mounted = !0, this.copyInputStyles(), this.updateInputWidth();
                }
              }, {
                key: "componentDidUpdate",
                value: function (e, t) {
                  t.inputWidth !== this.state.inputWidth && "function" == typeof this.props.onAutosize && this.props.onAutosize(this.state.inputWidth), this.updateInputWidth();
                }
              }, {
                key: "componentWillUnmount",
                value: function () {
                  this.mounted = !1;
                }
              }, {
                key: "copyInputStyles",
                value: function () {
                  if (this.mounted && window.getComputedStyle) {
                    var e = this.input && window.getComputedStyle(this.input);
                    e && (f(e, this.sizer), this.placeHolderSizer && f(e, this.placeHolderSizer));
                  }
                }
              }, {
                key: "updateInputWidth",
                value: function () {
                  if (this.mounted && this.sizer && void 0 !== this.sizer.scrollWidth) {
                    var e = void 0;
                    e = this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth) ? Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2 : this.sizer.scrollWidth + 2, (e += "number" === this.props.type && void 0 === this.props.extraWidth ? 16 : parseInt(this.props.extraWidth) || 0) < this.props.minWidth && (e = this.props.minWidth), e !== this.state.inputWidth && this.setState({
                      inputWidth: e
                    });
                  }
                }
              }, {
                key: "getInput",
                value: function () {
                  return this.input;
                }
              }, {
                key: "focus",
                value: function () {
                  this.input.focus();
                }
              }, {
                key: "blur",
                value: function () {
                  this.input.blur();
                }
              }, {
                key: "select",
                value: function () {
                  this.input.select();
                }
              }, {
                key: "renderStyles",
                value: function () {
                  var e = this.props.injectStyles;
                  return p && e ? i.default.createElement("style", {
                    dangerouslySetInnerHTML: {
                      __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
                    }
                  }) : null;
                }
              }, {
                key: "render",
                value: function () {
                  var e = [this.props.defaultValue, this.props.value, ""].reduce(function (e, t) {
                      return null != e ? e : t;
                    }),
                    t = r({}, this.props.style);
                  t.display || (t.display = "inline-block");
                  var n = r({
                      boxSizing: "content-box",
                      width: this.state.inputWidth + "px"
                    }, this.props.inputStyle),
                    o = function (e, t) {
                      var n = {};
                      for (var r in e) t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
                      return n;
                    }(this.props, []);
                  return function (e) {
                    c.forEach(function (t) {
                      return delete e[t];
                    });
                  }(o), o.className = this.props.inputClassName, o.id = this.state.inputId, o.style = n, i.default.createElement("div", {
                    className: this.props.className,
                    style: t
                  }, this.renderStyles(), i.default.createElement("input", r({}, o, {
                    ref: this.inputRef
                  })), i.default.createElement("div", {
                    ref: this.sizerRef,
                    style: s
                  }, e), this.props.placeholder ? i.default.createElement("div", {
                    ref: this.placeHolderSizerRef,
                    style: s
                  }, this.props.placeholder) : null);
                }
              }]), t;
            }(a.Component);
          y.propTypes = {
            className: u.default.string,
            defaultValue: u.default.any,
            extraWidth: u.default.oneOfType([u.default.number, u.default.string]),
            id: u.default.string,
            injectStyles: u.default.bool,
            inputClassName: u.default.string,
            inputRef: u.default.func,
            inputStyle: u.default.object,
            minWidth: u.default.oneOfType([u.default.number, u.default.string]),
            onAutosize: u.default.func,
            onChange: u.default.func,
            placeholder: u.default.string,
            placeholderIsMinWidth: u.default.bool,
            style: u.default.object,
            value: u.default.any
          }, y.defaultProps = {
            minWidth: 1,
            injectStyles: !0
          }, t.Z = y;
        },
        216: (e, t, n) => {
          "use strict";

          var r = n(138);
          function o() {}
          function a() {}
          a.resetWarningCache = o, e.exports = function () {
            function e(e, t, n, o, a, i) {
              if (i !== r) {
                var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw u.name = "Invariant Violation", u;
              }
            }
            function t() {
              return e;
            }
            e.isRequired = e;
            var n = {
              array: e,
              bool: e,
              func: e,
              number: e,
              object: e,
              string: e,
              symbol: e,
              any: e,
              arrayOf: t,
              element: e,
              elementType: e,
              instanceOf: t,
              node: e,
              objectOf: t,
              oneOf: t,
              oneOfType: t,
              shape: t,
              exact: t,
              checkPropTypes: a,
              resetWarningCache: o
            };
            return n.PropTypes = n, n;
          };
        },
        863: (e, t, n) => {
          e.exports = n(216)();
        },
        138: e => {
          "use strict";

          e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        787: t => {
          "use strict";

          t.exports = e;
        }
      },
      n = {};
    function r(e) {
      var o = n[e];
      if (void 0 !== o) return o.exports;
      var a = n[e] = {
        exports: {}
      };
      return t[e](a, a.exports, r), a.exports;
    }
    r.n = e => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return r.d(t, {
        a: t
      }), t;
    }, r.d = (e, t) => {
      for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var o = {};
    return (() => {
      "use strict";

      r.r(o), r.d(o, {
        JS__TOKEN__DELETE_BUTTON__CLASS_NAME: () => d,
        KEY_DOWN_HANDLER_CONFIG_OPTION: () => f,
        default: () => X
      });
      var e = r(787),
        t = r.n(e),
        n = r(697),
        a = r.n(n),
        i = r(184),
        u = r.n(i),
        l = r(639);
      const s = function () {},
        c = function (e, t) {
          var n = t.onBackspace,
            r = void 0 === n ? s : n,
            o = t.onTab,
            a = void 0 === o ? s : o,
            i = t.onEnter,
            u = void 0 === i ? s : i,
            l = t.onEscape,
            c = void 0 === l ? s : l;
          switch (function (e) {
            var t = e.key,
              n = e.keyCode,
              r = t;
            return n && 229 === n && (r = "Process"), {
              key: r
            };
          }(e).key) {
            case "Backspace":
              r(e);
              break;
            case "Tab":
              a(e);
              break;
            case "Enter":
              u(e);
              break;
            case "Escape":
              c(e);
          }
        };
      var f = {
          OFF: 0,
          ON: 1
        },
        p = {
          onBackspace: f.ON,
          onTab: f.OFF,
          onEnter: f.ON,
          onEscape: f.ON
        },
        d = "js__token__delete-button";
      function y(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function h(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? y(Object(n), !0).forEach(function (t) {
            b(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function b(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      var m = function (e) {
        var t = e.keyDownEvent,
          n = e.keyDownHandlerConfig,
          r = e.predefinedHandler;
        switch (!0) {
          case n === f.ON:
            r(t);
        }
      };
      const k = function (t) {
          var n = t.specialKeyDown,
            r = t.inputInitValue,
            o = t.inputValue,
            a = t.onLastTokenDelete,
            i = t.handleInputValueUpdate,
            u = t.handleTokensCreate,
            l = h(h({}, p), n),
            s = l.onBackspace,
            c = l.onTab,
            f = l.onEnter,
            d = l.onEscape;
          return {
            handleBackspaceKeyDown: (0, e.useCallback)(function (e) {
              m({
                keyDownEvent: e,
                keyDownHandlerConfig: s,
                predefinedHandler: function () {
                  0 === o.length && a();
                }
              });
            }, [s, o, a]),
            handleTabKeyDown: (0, e.useCallback)(function (e) {
              m({
                keyDownEvent: e,
                keyDownHandlerConfig: c,
                predefinedHandler: function (e) {
                  e.preventDefault(), u(o);
                }
              });
            }, [c, o, u]),
            handleEnterKeyDown: (0, e.useCallback)(function (e) {
              m({
                keyDownEvent: e,
                keyDownHandlerConfig: f,
                predefinedHandler: function () {
                  u(o);
                }
              });
            }, [f, o, u]),
            handleEscapeKeyDown: (0, e.useCallback)(function (e) {
              m({
                keyDownEvent: e,
                keyDownHandlerConfig: d,
                predefinedHandler: function () {
                  i(r);
                }
              });
            }, [d, r, i])
          };
        },
        v = "token-input-autosized-wrapper",
        g = "token-input-token";
      function T(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      var E = (0, e.forwardRef)(function (n, r) {
        var o,
          a,
          i = n.placeholder,
          u = n.autoFocus,
          s = n.onFocus,
          f = n.onBlur,
          p = n.separators,
          d = n.specialKeyDown,
          y = n.onInputValueChange,
          h = n.onPreprocess,
          b = n.onBuildTokenValue,
          m = n.onNewTokenValuesAppend,
          g = n.onLastTokenDelete,
          E = (o = (0, e.useState)(""), a = 2, function (e) {
            if (Array.isArray(e)) return e;
          }(o) || function (e, t) {
            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != n) {
              var r,
                o,
                a = [],
                i = !0,
                u = !1;
              try {
                for (n = n.call(e); !(i = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); i = !0);
              } catch (e) {
                u = !0, o = e;
              } finally {
                try {
                  i || null == n.return || n.return();
                } finally {
                  if (u) throw o;
                }
              }
              return a;
            }
          }(o, a) || function (e, t) {
            if (e) {
              if ("string" == typeof e) return T(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? T(e, t) : void 0;
            }
          }(o, a) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }()),
          w = E[0],
          S = E[1],
          O = (0, e.useMemo)(function () {
            return new RegExp(p.join("|"));
          }, [p]),
          C = (0, e.useCallback)(function (e) {
            S(e), y(e, w);
          }, [y, w, S]),
          I = (0, e.useCallback)(function (e) {
            if (0 !== e.trim().length) {
              var t = e.split(O).filter(function (e) {
                  return e.trim().length > 0;
                }),
                n = h(t).map(function (e) {
                  return b(e);
                });
              m(n), C("");
            }
          }, [O, h, b, m, C]),
          j = (0, e.useCallback)(function (e) {
            var t = e.target.value,
              n = t.substring(t.length - 1);
            !0 !== O.test(n) ? C(t) : I(w);
          }, [O, I, w, C]),
          A = k({
            specialKeyDown: d,
            inputInitValue: "",
            inputValue: w,
            onLastTokenDelete: g,
            handleInputValueUpdate: C,
            handleTokensCreate: I
          }),
          D = A.handleBackspaceKeyDown,
          V = A.handleTabKeyDown,
          R = A.handleEnterKeyDown,
          _ = A.handleEscapeKeyDown,
          P = (0, e.useCallback)(function (e) {
            c(e, {
              onBackspace: D,
              onTab: V,
              onEnter: R,
              onEscape: _
            });
          }, [D, V, R, _]),
          N = (0, e.useCallback)(function (e) {
            I(w), f(e);
          }, [I, w, f]),
          M = (0, e.useCallback)(function (e) {
            e.preventDefault();
            var t = e.clipboardData.getData("text");
            I(t);
          }, [I]);
        return t().createElement("div", {
          className: v
        }, t().createElement(l.Z, {
          ref: r,
          autoFocus: u,
          placeholder: i,
          value: w,
          onChange: j,
          onKeyDown: P,
          onPaste: M,
          onFocus: s,
          onBlur: N
        }));
      });
      E.displayName = "TokenCreator", E.propTypes = {
        placeholder: a().string.isRequired,
        autoFocus: a().bool.isRequired,
        onFocus: a().func.isRequired,
        onBlur: a().func.isRequired,
        separators: a().array.isRequired,
        specialKeyDown: a().object.isRequired,
        onInputValueChange: a().func.isRequired,
        onPreprocess: a().func.isRequired,
        onBuildTokenValue: a().func.isRequired,
        onNewTokenValuesAppend: a().func.isRequired,
        onLastTokenDelete: a().func.isRequired
      };
      const w = E,
        S = function () {
          return t().createElement("div", {
            role: "img",
            className: "token-input-delete-button__close-icon",
            "aria-hidden": "true",
            "data-component-name": "CloseIcon"
          });
        };
      var O = function (e) {
        var n = e.onRenderContent,
          r = "function" == typeof n;
        return t().createElement("span", {
          role: "button",
          className: u()(d, "token-input-token__delete-button"),
          "aria-hidden": "true",
          "data-component-name": "DeleteButton"
        }, r && n(), !r && t().createElement(S, null));
      };
      O.propTypes = {
        onRenderContent: a().func
      };
      const C = O;
      function I(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function j(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      var A = function (e) {
          e.stopPropagation();
        },
        D = function (n) {
          var r,
            o,
            a = n.readOnly,
            i = n.tokenValue,
            s = n.tokenMeta,
            f = n.onGetClassName,
            p = n.onGetDisplayLabel,
            y = n.onRenderDeleteButtonContent,
            h = n.onIsEditable,
            b = n.onGetEditableValue,
            m = n.onGetErrorMessage,
            k = n.onBuildTokenValue,
            T = n.onEditStart,
            E = n.onEditEnd,
            w = n.onDelete,
            S = (0, e.useRef)(null),
            O = (r = (0, e.useState)(""), o = 2, function (e) {
              if (Array.isArray(e)) return e;
            }(r) || function (e, t) {
              var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
              if (null != n) {
                var r,
                  o,
                  a = [],
                  i = !0,
                  u = !1;
                try {
                  for (n = n.call(e); !(i = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); i = !0);
                } catch (e) {
                  u = !0, o = e;
                } finally {
                  try {
                    i || null == n.return || n.return();
                  } finally {
                    if (u) throw o;
                  }
                }
                return a;
              }
            }(r, o) || function (e, t) {
              if (e) {
                if ("string" == typeof e) return j(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? j(e, t) : void 0;
              }
            }(r, o) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }()),
            D = O[0],
            V = O[1],
            R = s.activated,
            _ = s.error,
            P = (0, e.useMemo)(function () {
              return h(i, s);
            }, [h, i, s]),
            N = (0, e.useCallback)(function () {
              var e = b(i, s);
              V(e), T();
            }, [V, i, s, b, T]);
          (0, e.useEffect)(function () {
            R && S.current && S.current.focus();
          }, [R]);
          var M = (0, e.useCallback)(function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = e.reset,
                n = void 0 !== t && t,
                r = 0 === D.length;
              if (n || r) E();else {
                var o = k(D);
                E(o);
              }
            }, [D, k, E]),
            x = (0, e.useCallback)(function (e) {
              e.stopPropagation(), a || (e.target.closest(".".concat(g, " .").concat(d)) ? w() : P && N());
            }, [a, P, w, N]),
            B = (0, e.useCallback)(function (e) {
              var t = e.target.value;
              V(t);
            }, [V]),
            W = (0, e.useCallback)(function (e) {
              c(e, {
                onEscape: function () {
                  return M({
                    reset: !0
                  });
                },
                onEnter: function () {
                  return M();
                }
              });
            }, [M]),
            G = (0, e.useCallback)(function () {
              M();
            }, [M]),
            q = (0, e.useMemo)(function () {
              var e;
              return u()(f(i, s), g, (I(e = {}, "token-input-token--read-only", a), I(e, "token-input-token--editable", P && !a), I(e, "token-input-token--active", R), I(e, "token-input-token--error", _ && !R), e));
            }, [f, a, P, R, _, i, s]),
            F = (0, e.useMemo)(function () {
              return m(i, s);
            }, [m, i, s]);
          return R ? t().createElement("div", {
            role: "presentation",
            className: q,
            onClick: A
          }, t().createElement("div", {
            className: v
          }, t().createElement(l.Z, {
            ref: S,
            value: D,
            onChange: B,
            onKeyDown: W,
            onBlur: G
          }))) : t().createElement("div", {
            role: "presentation",
            className: q,
            onClick: x,
            title: F,
            "data-component-name": "Token"
          }, t().createElement("div", {
            className: "token-input-token__label-wrapper"
          }, p(i, s)), !a && t().createElement(C, {
            onRenderContent: y
          }));
        };
      D.propTypes = {
        readOnly: a().bool.isRequired,
        tokenValue: a().any.isRequired,
        tokenMeta: a().object.isRequired,
        onGetClassName: a().func.isRequired,
        onGetDisplayLabel: a().func.isRequired,
        onRenderDeleteButtonContent: a().func,
        onIsEditable: a().func.isRequired,
        onGetEditableValue: a().func.isRequired,
        onGetErrorMessage: a().func.isRequired,
        onBuildTokenValue: a().func.isRequired,
        onEditStart: a().func.isRequired,
        onEditEnd: a().func.isRequired,
        onDelete: a().func.isRequired
      };
      const V = D;
      function R(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      const _ = function () {
          var t,
            n,
            r = (t = (0, e.useState)(!1), n = 2, function (e) {
              if (Array.isArray(e)) return e;
            }(t) || function (e, t) {
              var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
              if (null != n) {
                var r,
                  o,
                  a = [],
                  i = !0,
                  u = !1;
                try {
                  for (n = n.call(e); !(i = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); i = !0);
                } catch (e) {
                  u = !0, o = e;
                } finally {
                  try {
                    i || null == n.return || n.return();
                  } finally {
                    if (u) throw o;
                  }
                }
                return a;
              }
            }(t, n) || function (e, t) {
              if (e) {
                if ("string" == typeof e) return R(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? R(e, t) : void 0;
              }
            }(t, n) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }()),
            o = r[0],
            a = r[1];
          return {
            isTokenInputFocused: o,
            handleTokenInputFocus: (0, e.useCallback)(function () {
              a(!0);
            }, []),
            handleTokenInputBlur: (0, e.useCallback)(function () {
              a(!1);
            }, [])
          };
        },
        P = function (e, t, n) {
          return {
            key: "".concat(JSON.stringify(t), "-").concat(Date.now(), "-").concat(n),
            activated: !1,
            error: e
          };
        };
      function N(e, t) {
        if (e) {
          if ("string" == typeof e) return M(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? M(e, t) : void 0;
        }
      }
      function M(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      const x = function () {
        var t,
          n,
          r = (t = (0, e.useState)([]), n = 2, function (e) {
            if (Array.isArray(e)) return e;
          }(t) || function (e, t) {
            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != n) {
              var r,
                o,
                a = [],
                i = !0,
                u = !1;
              try {
                for (n = n.call(e); !(i = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); i = !0);
              } catch (e) {
                u = !0, o = e;
              } finally {
                try {
                  i || null == n.return || n.return();
                } finally {
                  if (u) throw o;
                }
              }
              return a;
            }
          }(t, n) || N(t, n) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }()),
          o = r[0],
          a = r[1],
          i = (0, e.useCallback)(function (e, t) {
            if (e >= o.length) throw new Error("setTokenActivated out of tokenMetas scope; targetIndex ".concat(e, "; tokenMetas.length ").concat(o.length));
            var n = function (e) {
              return function (e) {
                if (Array.isArray(e)) return M(e);
              }(e) || function (e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
              }(e) || N(e) || function () {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }();
            }(o);
            n[e].activated = t, a(n);
          }, [o]);
        return {
          buildTokenMeta: P,
          tokenMetas: o,
          setTokenMetas: a,
          setTokenActivated: i
        };
      };
      function B(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (null != n) {
            var r,
              o,
              a = [],
              i = !0,
              u = !1;
            try {
              for (n = n.call(e); !(i = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); i = !0);
            } catch (e) {
              u = !0, o = e;
            } finally {
              try {
                i || null == n.return || n.return();
              } finally {
                if (u) throw o;
              }
            }
            return a;
          }
        }(e, t) || W(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function W(e, t) {
        if (e) {
          if ("string" == typeof e) return G(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? G(e, t) : void 0;
        }
      }
      function G(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      const q = function (t) {
        var n = t.tokenValues,
          r = t.onTokenValueValidate,
          o = x(),
          a = o.buildTokenMeta,
          i = o.tokenMetas,
          u = o.setTokenMetas,
          l = o.setTokenActivated,
          s = B((0, e.useState)(!1), 2),
          c = s[0],
          f = s[1],
          p = B((0, e.useState)([]), 2),
          d = p[0],
          y = p[1];
        return (0, e.useLayoutEffect)(function () {
          var e,
            t = !1,
            o = n.map(function (e, o) {
              var i = r(e, o, n),
                u = a(i, e, o);
              return u.error && !u.activated && (t = !0), u;
            });
          y(function (e) {
            if (Array.isArray(e)) return G(e);
          }(e = n) || function (e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
          }(e) || W(e) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }()), u(o), f(t);
        }, [n, r, u, a]), {
          hasInvalidToken: c,
          internalTokenValues: d,
          tokenMetas: i,
          setTokenActivated: l
        };
      };
      function F(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      const z = function (t) {
        var n = t.tokenValues,
          r = t.onTokenValuesChange,
          o = t.setTokenActivated,
          a = t.handleTokenInputFocus,
          i = t.handleTokenInputBlur;
        return {
          handleTokenEditStart: (0, e.useCallback)(function (e) {
            return function () {
              o(e, !0), a();
            };
          }, [o, a]),
          handleTokenEditEnd: (0, e.useCallback)(function (e) {
            return function (t) {
              if (o(e, !1), i(), void 0 !== t) {
                var a = function (e) {
                  if (Array.isArray(e)) return F(e);
                }(u = n) || function (e) {
                  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(u) || function (e, t) {
                  if (e) {
                    if ("string" == typeof e) return F(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? F(e, t) : void 0;
                  }
                }(u) || function () {
                  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
                a[e] = t, r(a);
              }
              var u;
            };
          }, [n, r, o, i])
        };
      };
      function L(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      const K = function (t) {
          var n = t.tokenValues,
            r = t.onTokenValuesChange,
            o = t.focusTokenCreator,
            a = (0, e.useCallback)(function (e) {
              var t,
                a = function (e) {
                  if (Array.isArray(e)) return L(e);
                }(t = n) || function (e) {
                  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(t) || function (e, t) {
                  if (e) {
                    if ("string" == typeof e) return L(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? L(e, t) : void 0;
                  }
                }(t) || function () {
                  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
              a.splice(e, 1), r(a), o();
            }, [n, r, o]);
          return {
            handleTokenDelete: (0, e.useCallback)(function (e) {
              return function () {
                a(e);
              };
            }, [a]),
            handleLastTokenDelete: (0, e.useCallback)(function () {
              a(-1);
            }, [a])
          };
        },
        H = function (e, t) {
          return e;
        };
      var U = ["className", "readOnly", "autoFocus", "placeholder", "tokenValues", "onTokenValuesChange", "onBuildTokenValue", "customizeTokenComponent", "onGetTokenClassName", "onGetTokenDisplayLabel", "onRenderTokenDeleteButtonContent", "onIsTokenEditable", "onGetTokenEditableValue", "onGetTokenErrorMessage", "separators", "specialKeyDown", "onPreprocess", "onInputValueChange", "onTokenValueValidate"];
      function $() {
        return ($ = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
      }
      function Y(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function Z(e) {
        return function (e) {
          if (Array.isArray(e)) return J(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return J(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? J(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function J(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      var Q = function (n) {
        var r,
          o = n.className,
          a = n.readOnly,
          i = n.autoFocus,
          l = n.placeholder,
          s = n.tokenValues,
          c = n.onTokenValuesChange,
          f = n.onBuildTokenValue,
          p = n.customizeTokenComponent,
          d = n.onGetTokenClassName,
          y = n.onGetTokenDisplayLabel,
          h = n.onRenderTokenDeleteButtonContent,
          b = n.onIsTokenEditable,
          m = n.onGetTokenEditableValue,
          k = n.onGetTokenErrorMessage,
          v = n.separators,
          g = n.specialKeyDown,
          T = n.onPreprocess,
          E = n.onInputValueChange,
          S = n.onTokenValueValidate,
          O = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              o = function (e, t) {
                if (null == e) return {};
                var n,
                  r,
                  o = {},
                  a = Object.keys(e);
                for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
              }(e, t);
            if (Object.getOwnPropertySymbols) {
              var a = Object.getOwnPropertySymbols(e);
              for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
          }(n, U),
          C = _(),
          I = C.isTokenInputFocused,
          j = C.handleTokenInputFocus,
          A = C.handleTokenInputBlur,
          D = function () {
            var t = (0, e.useRef)(null),
              n = (0, e.useCallback)(function () {
                t && t.current && t.current.focus();
              }, []);
            return {
              tokenCreatorRef: t,
              focusTokenCreator: n
            };
          }(),
          R = D.tokenCreatorRef,
          P = D.focusTokenCreator,
          N = q({
            tokenValues: s,
            onTokenValueValidate: S
          }),
          M = N.hasInvalidToken,
          x = N.internalTokenValues,
          B = N.tokenMetas,
          W = N.setTokenActivated,
          G = z({
            tokenValues: s,
            onTokenValuesChange: c,
            setTokenActivated: W,
            handleTokenInputFocus: j,
            handleTokenInputBlur: A
          }),
          F = G.handleTokenEditStart,
          L = G.handleTokenEditEnd,
          H = K({
            tokenValues: s,
            onTokenValuesChange: c,
            focusTokenCreator: P
          }),
          J = H.handleTokenDelete,
          Q = H.handleLastTokenDelete,
          X = (0, e.useCallback)(function (e) {
            if (0 !== e.length) {
              var t = [].concat(Z(s), Z(e));
              c(t);
            }
          }, [s, c]),
          ee = (0, e.useCallback)(function (e) {
            if ("function" != typeof T) return e;
            var t = T(e);
            if (!0 !== Array.isArray(t)) throw new Error("onPreprocess should return an array of values");
            return t;
          }, [T]),
          te = p || V;
        return t().createElement("div", $({}, O, {
          className: u()(o, "token-input-container", (r = {}, Y(r, "token-input-container--focused", I), Y(r, "token-input-container--errors", M), r)),
          onClick: P,
          role: "presentation",
          "data-component-name": "TokenInput"
        }), t().createElement("div", {
          className: "token-input-token-list"
        }, x.map(function (e, n) {
          var r = B[n],
            o = r.key;
          return t().createElement(te, {
            key: o,
            readOnly: a,
            tokenValue: e,
            tokenMeta: r,
            onGetClassName: d,
            onGetDisplayLabel: y,
            onRenderDeleteButtonContent: h,
            onIsEditable: b,
            onGetEditableValue: m,
            onGetErrorMessage: k,
            onBuildTokenValue: f,
            onEditStart: F(n),
            onEditEnd: L(n),
            onDelete: J(n)
          });
        })), !a && t().createElement(w, {
          ref: R,
          placeholder: l,
          autoFocus: i,
          onFocus: j,
          onBlur: A,
          separators: v,
          specialKeyDown: g,
          onInputValueChange: E,
          onPreprocess: ee,
          onBuildTokenValue: f,
          onNewTokenValuesAppend: X,
          onLastTokenDelete: Q
        }));
      };
      Q.propTypes = {
        style: a().object,
        className: a().string,
        readOnly: a().bool,
        autoFocus: a().bool,
        placeholder: a().string,
        separators: a().array,
        tokenValues: a().array.isRequired,
        onTokenValuesChange: a().func,
        onPreprocess: a().func,
        onBuildTokenValue: a().func,
        onInputValueChange: a().func,
        onTokenValueValidate: a().func,
        onGetTokenClassName: a().func,
        onGetTokenDisplayLabel: a().func,
        onRenderTokenDeleteButtonContent: a().func,
        onIsTokenEditable: a().func,
        onGetTokenEditableValue: a().func,
        onGetTokenErrorMessage: a().func,
        customizeTokenComponent: a().func,
        specialKeyDown: a().object
      }, Q.defaultProps = {
        className: "",
        readOnly: !1,
        autoFocus: !1,
        placeholder: "",
        separators: [",", ";", "\n", "\r", "\r\n"],
        specialKeyDown: {
          onBackspace: 1,
          onTab: 0,
          onEnter: 1,
          onEscape: 1
        },
        onBuildTokenValue: function (e) {
          return e.trim();
        },
        onInputValueChange: s,
        onTokenValueValidate: s,
        onTokenValuesChange: s,
        onGetTokenClassName: s,
        onGetTokenDisplayLabel: H,
        onIsTokenEditable: function () {
          return !0;
        },
        onGetTokenEditableValue: H,
        onGetTokenErrorMessage: function (e, t) {
          if ("string" == typeof t.error) return t.error;
        }
      };
      const X = Q;
    })(), o;
  })();
});